module.exports = __webpack_public_path__ + "static/media/possible.17ff1644.webp";